<div class="onboarding-step-wrapper">
    <h2>Financial long-term maintenance and contingency fund</h2>
    <div class="onboarding-blurb">
        <p>Long-term Maintenance (LTM) Plan and the provision of a contingency fund is a requirement for certain types of development.
            This feature can be enabled here. You can also set a particular account in your chart of accounts for use as the contingency fund for the LTMP.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <form [formGroup]="financialForm" class="cas-flex-column">
                <acabim-form-block labelWidth="12" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Contingency account</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-checkbox formControlName="contingency" [binary]="true"></p-checkbox>
                            <p-dropdown
                                    *ngIf="showContingencyAccounts"
                                    appendTo="body"
                                    formControlName="contingencyFund"
                                    placeholder="Select Account"
                                    [group]="true"
                                    [options]="accounts"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Maintenance items</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-checkbox formControlName="maintenanceItems" [binary]="true"></p-checkbox>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
                <button (click)="submit(true)" class="cas-button-action">Update</button>
            </form>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
